import type { AxiosProgressEvent, CancelToken } from "axios";

import type { IPickMutation } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { IUsersAvatar } from "./routeType";

const { getPath } = getApi("users.avatar.post");

type IExtractedRouteType = IUsersAvatar["userAvatarSingleUpload"];

export type IPostUserAvatar = IPickMutation<IExtractedRouteType>;

// const postUserAvatar: Fetcher<
//   IPostUserAvatar["response"],
//   IPostUserAvatar["variables"]
// > = ({ userId, ...data }) => {
//   return axiosClient.put(getPath({ userId }), data);
// };

export const postUserAvatar = (userId: string) =>
  function uploadFileAPI(
    file: File,
    progressCallBack?: (progressEvent: AxiosProgressEvent) => void,
    cancelToken?: CancelToken,
  ): Promise<IPostUserAvatar["response"]> {
    const data = new FormData();

    data.append("avatar", file);

    return axiosClient.post(getPath({ userId }), data, {
      onUploadProgress(progressEvent) {
        progressCallBack?.(progressEvent);
      },
      cancelToken,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  };

// TODO:
// queryClient.invalidateQueries({ queryKey: useGetAllUser.getKey() });
// queryClient.invalidateQueries({
//   queryKey: useGetUser.getKey({ userId }),
// });
// queryClient.invalidateQueries({
//   queryKey: useGetProfile.getKey(),
// });
